<template>
  <!-- The app window every story screen draws in: the shell's page and wash colours, hairlines at
       onSurface 12%, Space Grotesk and the AppTone colours, the same tokens as
       components/motion/AiChatWindow.vue. The header carries the screen's own title (an app
       string); the body is the screen. Replicas are decorative (`aria-hidden`); the page copy
       beside them tells the story. -->
  <div class="saw" aria-hidden="true">
    <header class="saw-head">
      <span class="saw-title">
        <svg v-if="icon" viewBox="0 0 24 24"><path :d="icon" /></svg>
        <span>
          <b>{{ title }}</b>
          <small v-if="sub">{{ sub }}</small>
        </span>
      </span>
      <slot name="actions" />
    </header>
    <div class="saw-body">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  sub: { type: String, default: "" },
  icon: { type: String, default: "" },
});
</script>

<style src="~/assets/css/story-app-window.css"></style>
